import Header from "./Header";

const Navigation = ({children}) => {
    return (
        <div className="dashboard-wrapper">
            <div className="dashboard-content">
                <Header />
                {children}
            </div>
        </div>
    );
};

export default Navigation;
